// extracted by mini-css-extract-plugin
export default {"root":"styles-module___root___f63cdfe2","cellCentered":"styles-module___cellCentered___dec35f7c","headerCentered":"styles-module___headerCentered___f9dd23c1"};